import axiosInstance from "../../../utils/axios";

const path = "/common"

export const globalSetting = async (values) => {
    return await axiosInstance().get(`${path}/global-settings`, values);
}

export const cmsPage = async (values) => {
  return await axiosInstance().get(`${path}/cms-page?slug=${values.slug}`);
}

export const cmsOption = async (values) => {
  return await axiosInstance().post(`${path}/cms-option`, values);
}


export const Inquiry = async (values) => {
  return await axiosInstance().post(`${path}/add-inquiry`, values);
}

export const subjectList = async () => {
  return await axiosInstance().get(`${path}/subject-list`);
}

export const faqList = async (values) => {
  return await axiosInstance().post(`${path}/faq-list`, values);
}

export const GetBanners = async (values) => {
  return await axiosInstance().get(`${path}/banner`, values);
}

export const GetStreams = async (query) => {
  return await axiosInstance().get(`${path}/streams${query}`);
}

export const GetStreamToken = async (userID, roomID) => {
  return await axiosInstance().get(`${path}/streams/getToken?userID=${userID}&roomID=${roomID}`);
};







